import React, { useEffect, useRef, useState } from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import { useGlobalState } from '../../state/GlobalStateProvider';

// const geoUrl = 'https://gist.githubusercontent.com/hrbrmstr/91ea5cc9474286c72838/raw/59421ff9b268ff0929b051ddafafbeb94a4c1910/continents.json';

const geoUrl = require('../../assets/map.json');
const Map = ({ handleSidebar, handleContinent, handleDisplayContinent, displayContinet }) => {
  const [hoveredGeo, setHoveredGeo] = useState(null);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const mapContainerRef = useRef(null);
  const [scale, setScale] = useState();
  const [{ user }] = useGlobalState();

  const updateDimensions = () => {
    if (mapContainerRef.current) {
      const { offsetWidth, offsetHeight } = mapContainerRef.current;
      console.log({offsetHeight , offsetWidth})
      setDimensions({ 
        width: offsetWidth || 1200, // Default to 1200px if width is 0
        height: offsetHeight || 800  // Default to 800px if height is 0
      });
    }
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const handleMouseEnter = (geo, event) => {
    setHoveredGeo(geo);
    const section = event.currentTarget;
    const rect = section.getBoundingClientRect();
    setCursorPosition({ x: event.clientX - rect.left, y: event.clientY - rect.top });
  };

  const handleMouseLeave = () => {
    setHoveredGeo(null);
  };

  const handleMouseMove = event => {
    const section = event.currentTarget;
    const rect = section.getBoundingClientRect();
    setCursorPosition({ x: event.clientX - rect.left, y: event.clientY - rect.top });
  };

  const handleClick = geo => {
    if (geo.properties.CONTINENT === 'Antarctica') return;

    const continentName = geo.properties.CONTINENT;
    handleContinent(continentName);
    handleSidebar();
  };

  useEffect(() => {
    handleDisplayContinent(hoveredGeo?.properties?.CONTINENT);
  }, [hoveredGeo, handleDisplayContinent]);

  useEffect(() => {
    if (dimensions.width) {
      let ss = Math.abs((Number(dimensions.width) - 1344) / 12);
      setScale(190 + ss);
    }
  }, [dimensions]);

  return (
    <div className='whitelist_wrapper__map' onMouseMove={handleMouseMove} ref={mapContainerRef}>
      <ComposableMap
        projection='geoEqualEarth'
        width={dimensions?.width * 1 || 1200}
        height={dimensions?.height * 1 || 1000}
        projectionConfig={{
          rotate: [0, 0, 0],
          scale: [scale],
        }}
        style={{
          width: dimensions?.width || 1200, 
          height: dimensions?.height || 800,
        }}
      >
        <defs>
          {/* Default dotted texture */}
          <pattern id='defaultDottedTexture' x='0' y='0' width='6' height='6' patternUnits='userSpaceOnUse'>
            <circle cx='2' cy='2' r='1.5' fill='#737272' />
          </pattern>

          {/* Hover dotted texture */}
          <pattern id='hoverDottedTexture' x='0' y='0' width='6' height='6' patternUnits='userSpaceOnUse'>
            <circle cx='2' cy='2' r='1.5' fill='#E7EAFF' />
          </pattern>
        </defs>

        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map(geo => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                onMouseEnter={event => handleMouseEnter(geo, event)}
                onMouseLeave={handleMouseLeave}
                onClick={() => handleClick(geo)}
                style={{
                  default: {
                    fill: hoveredGeo === geo ? 'url(#hoverDottedTexture)' : 'url(#defaultDottedTexture)',
                    outline: 'none',
                  },
                  hover: {
                    fill: 'url(#hoverDottedTexture)',
                    outline: 'none',
                    cursor: 'none', // Hide default cursor
                  },
                  pressed: { fill: '#E7EAFF', outline: 'none' },
                }}
              />
            ))
          }
        </Geographies>
      </ComposableMap>
      {hoveredGeo && (
        <div
          className='overlapping_button'
          style={{
            top: `${cursorPosition.y}px`, // Offset to avoid overlap with the cursor
            left: `${cursorPosition.x}px`,
          }}
        >
          {user?.seedApplicant ? 'View Application' : displayContinet == 'Antarctica' ? 'WTF?? Really!?' : `Apply for ${displayContinet}`}
        </div>
      )}
    </div>
  );
};

export default Map;
